import * as React from 'react';

function SvgLocationOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M12 2C8.179 2 5.078 4.952 5.078 8.587c0 4.183 4.616 10.811 6.31 13.101a.758.758 0 001.227 0c1.694-2.289 6.31-8.915 6.31-13.101C18.924 4.952 15.823 2 12.001 2z" }),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M12 11.232a2.308 2.308 0 100-4.616 2.308 2.308 0 000 4.616z" })));
}

export default SvgLocationOutline;
